import { Component, OnInit, ViewChild } from '@angular/core';
import { UserDetailComponent } from '../user/user-detail/user-detail.component';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../shared/user.service';
import { TripService } from '../service/trip.service';
import { Cycle, OrderStatus, Site, TripCategory } from '../model/trip';
//import { TripCycleDetailsComponent } from '../trip-cycle-details/trip-cycle-details.component';
import { ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { TripCycleDetails2Component } from '../trip-cycle-details-2/trip-cycle-details-2.component';

@Component({
  providers: [UserDetailComponent],
  selector: 'trip-cycles-2',
  templateUrl: './trip-cycles-2.component.html',
  styleUrls: ['./trip-cycles-2.component.css']
})
export class TripCycles2Component implements OnInit {

  @ViewChild (TripCycleDetails2Component) tripCycleDetails2Component: TripCycleDetails2Component; 

  
  allSites: Site[];
  sites: Site[];
  selectedSite: Site = null;
  // tripTypes: TripType[];
  // selectedtripType: TripType = null;
  categories: TripCategory[];
  selectedCategory: TripCategory = null;
  orderStatuses: OrderStatus[];
  selectedOrderStatus: OrderStatus = null;
  userDetails: any = null;
  cols: any[];
  msgs: any[] = [];
  cycles: Cycle[];
  cyclesFiltered: Cycle[];
  //selectedCycle: Cycle = null;
  selectedCycleId: number = null;

  groupers: SelectItem[] = null;
  selectedGrouper: string = null;

  parametersApplyed: boolean = false;
  // tid: number;
  catid: number;
  sid: number;
  cid: number;
  statusid: number;
  grouper: string;

  resCode: string;

  viewDetails: boolean = false;



  constructor(private userService: UserService, private tripService: TripService, private route:ActivatedRoute) { }

  ngOnInit() {
    this.parametersApplyed = false;
    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;
      if (this.userDetails.ClientRoleAdministration || this.userDetails.ClientRoleSupplier || this.userDetails.ClientRoleAllViewer) {
        

          this.tripService.getSites().subscribe((result: any) => {
            
            this.allSites = result
            //this.tripTypes = this.getTripTypes(this.allSites);
            this.categories = this.getCategories(this.allSites);
            this.orderStatuses = this.getOrderStatuses(this.allSites);
            this.sites = this.clone(this.allSites);

            
            this.sites = result;
            //this.selectedSite = this.sites[1];  
            //this.siteSelected();      
            this.cycles = null;
            this.cyclesFiltered = null;

            this.applyParameters();
          },
            (err: HttpErrorResponse) => {
              this.showMessage('error', '', 'שגיאה בקבלת אתרי יעד');
          });
      }
      else {
        this.sites = null;
      }
    },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
        this.showMessage('error', '', 'שגיאה בקבלת הרשאות');
      });

    
  }

  applyParameters() {
    // this.tid = this.route.snapshot.params['tid'];
    // if (this.tid==0) {this.tid = null;}
    // this.sid = this.route.snapshot.params['sid'];
    // this.cid = this.route.snapshot.params['cid'];
    // if (this.cid==0) {this.cid = null;}
    // this.statusid = this.route.snapshot.params['statusid'];
    // if (this.statusid==0) {this.statusid = null;}
    // this.grouper = this.route.snapshot.params['grouper'];
    // if (this.grouper=='null') {this.grouper=null;}

    //this.resCode = this.route.snapshot.queryParams['resCode'];
    let resC = sessionStorage.getItem('resCode');
    sessionStorage.removeItem('resCode');

    if (!resC || resC == '') {
      // no parameters
      return;
    }

    let res = JSON.parse(resC);
    this.catid = res.catid;
    this.sid = res.sid;
    this.cid = res.cid;
    this.statusid = res.statusid;
    this.grouper = res.grouper;
    this.resCode = res.resCode;

    // console.log(this.tid);
    console.log(this.catid);
    console.log(this.sid);
    console.log(this.cid);
    console.log(this.statusid);
    console.log(this.grouper);
    console.log(this.resCode);

    if (this.resCode == '1') {
      this.showMessage('success', '', 'שינוי פרטי כרטיס בוצע בהצלחה');
    } else if (this.resCode == '2') {
      this.showMessage('error', '', 'תקלה בשינוי פרטי כרטיס');
    } else if (this.resCode == '3') {
      this.showMessage('error', '', 'תקלה בפעולת עדכון פרטי כרטיס');
    } else if (this.resCode == '4') {
      this.showMessage('error', '', 'פעולת עדכון פרטי כרטיס בוטלה');
    }

    if (this.sid) {
      this.parametersApplyed = true;

      if (this.statusid) {
        let stat = this.orderStatuses.filter(f=>f.OrderStatusId == this.statusid);
        if (stat && stat.length == 1) {
          this.selectedOrderStatus = stat[0];
          //this.siteSelected();
        }
      }

      // let t = this.tripTypes.filter(f=>f.TripTypeId == this.tid);
      // if (t && t.length == 1) {
      //   this.selectedtripType = t[0];
      //   this.tripTypeSelected();

      //   let s = this.sites.filter(f=>f.SiteId==this.sid);
      //   if (s && s.length == 1) {
      //     this.selectedSite = s[0];
      //     //this.siteSelected();
      //   }

      // }

      let cat = this.categories.filter(f=>f.TripCategoryId == this.catid);
      if (cat && cat.length == 1) {
        this.selectedCategory = cat[0];
        this.categorySelected();

        let s = this.sites.filter(f=>f.SiteId==this.sid);
        if (s && s.length == 1) {
          this.selectedSite = s[0];
          //this.siteSelected();
        }

      }


      if (this.sid) {
        let s = this.sites.filter(f=>f.SiteId==this.sid);
        if (s && s.length == 1) {
          this.selectedSite = s[0];
        }
      }

      if (this.grouper) {
        this.selectedGrouper = this.grouper;
      }

      this.siteSelected();
      



      window.setTimeout(()=>{this.parametersApplyed = false;}, 3000);
    }
  }

  // getTripTypes(sites: Site[]) : TripType[] {
  //   let t: TripType[] = [];
  //   sites.forEach(f=>{ 
  //     if (!t.find(p=>p.TripTypeId == f.TripTypeId)) {
  //       t.push({TripTypeId: f.TripTypeId, TripType: f.TripType});
  //     }
  //   });
  //   return t;
  // }

  getCategories(sites: Site[]) : TripCategory[] {
    let t: TripCategory[] = [];
    sites.forEach(f=>{ 
      if (!t.find(p=>p.TripCategoryId == f.TripCategoryId)) {
        t.push({TripCategoryId: f.TripCategoryId, CategoryName: f.CategoryName});
      }
    });
    t.sort((a, b) => 
      a.CategoryName.localeCompare(b.CategoryName)
    );
    return t;
  }

  getOrderStatuses(sites: Site[]) : OrderStatus[] {
    let t: OrderStatus[] = [];
    sites.forEach(f=>{ 
      if (!t.find(p=>p.OrderStatusId == f.OrderStatusId)) {
        t.push({OrderStatusId: f.OrderStatusId, OrderStatus: f.OrderStatus});
      }
    });
    return t;
  }

  // tripTypeSelected() {
  //   this.viewDetails = false;
  //   this.tripCycleDetails2Component.clearData();
  //   this.selectedSite = null;
  //   this.cycles = null;
  //   this.cyclesFiltered = null;

  //   // if (this.selectedtripType && this.selectedtripType.TripTypeId) {
  //   //   this.sites = this.allSites.filter(f=>f.TripTypeId == this.selectedtripType.TripTypeId);
  //   // } else {
  //   //   this.sites = this.clone(this.allSites);
  //   // }
  //   this.filterSites();
  // }

  categorySelected() {
    this.viewDetails = false;
    this.tripCycleDetails2Component.clearData();
    this.selectedSite = null;
    this.cycles = null;
    this.cyclesFiltered = null;

    // if (this.selectedtripType && this.selectedtripType.TripTypeId) {
    //   this.sites = this.allSites.filter(f=>f.TripTypeId == this.selectedtripType.TripTypeId);
    // } else {
    //   this.sites = this.clone(this.allSites);
    // }
    this.filterSites();
  }

  orderStatusSelected() {
    this.viewDetails = false;
    this.tripCycleDetails2Component.clearData();
    this.selectedSite = null;
    this.cycles = null;
    this.cyclesFiltered = null;

    // if (this.selectedOrderStatus && this.selectedOrderStatus.OrderStatusId) {
    //   this.sites = this.allSites.filter(f=>f.OrderStatusId == this.selectedOrderStatus.OrderStatusId);
    // } else {
    //   this.sites = this.clone(this.allSites);
    // }
    this.filterSites();
  }

  filterSites() {
    this.sites = this.clone(this.allSites);
    if (this.selectedCategory && this.selectedCategory.TripCategoryId) {
      this.sites = this.sites.filter(f=>f.TripCategoryId == this.selectedCategory.TripCategoryId);
    }
    if (this.selectedOrderStatus && this.selectedOrderStatus.OrderStatusId) {
      this.sites = this.sites.filter(f=>f.OrderStatusId == this.selectedOrderStatus.OrderStatusId);
    }
  }

  siteSelected() {
    this.viewDetails = false;
    this.tripCycleDetails2Component.clearData();
    this.selectedCycleId = null;
    if (!this.selectedSite) {
      this.cycles = null;
      this.cyclesFiltered = null;
      return;
    }



    this.tripService.getCycles(this.selectedSite.SiteId).subscribe((result: any) => {
      this.cyclesFiltered = null;
      this.cycles = result.map(m=>{m.label = m.CycleName; m.value = m.CycleId; return m;});
      console.log(this.cycles);
      let nonEmpyGrouper = this.cycles.find(f=>f.CycleGrouper!=null && f.CycleGrouper!='');
      if (nonEmpyGrouper) {
        this.selectedGrouper = null;
        this.setGroupers();
        this.cols = [
          { field: 'CycleGrouper', header: 'מקבץ', width: '100', priority: '' },
          { field: 'CycleName', header: 'שם מחזור', priority: '' },
          { field: 'StartDate', header: 'תאריך יציאה', width: '120', priority: '' },
          { field: 'EndDate', header: 'תאריך חזרה', width: '120', priority: '' },
          { field: 'CardsBillSuccess', header: 'חויבו', width: '80', priority: 'ui-p-3' },
          { field: 'CardsBillFailure', header: 'נכשלו', width: '80', priority: 'ui-p-3' },
          { field: 'CardsPending', header: 'טרם חויבו', width: '80', priority: 'ui-p-3' },
        ];
      } else {
        this.selectedGrouper = null;
        this.groupers = null;
        this.cols = [
          { field: 'CycleName', header: 'שם מחזור', priority: '' },
          { field: 'StartDate', header: 'תאריך יציאה', width: '120', priority: '' },
          { field: 'EndDate', header: 'תאריך חזרה', width: '120', priority: '' },
          { field: 'CardsBillSuccess', header: 'חויבו', width: '80', priority: 'ui-p-3' },
          { field: 'CardsBillFailure', header: 'נכשלו', width: '80', priority: 'ui-p-3' },
          { field: 'CardsPending', header: 'טרם חויבו', width: '80', priority: 'ui-p-3' },
        ];
      }

      if (this.parametersApplyed && this.cid) {
        let c = this.cycles.filter(f=>f.CycleId == this.cid);
        if (c && c.length == 1) {
          this.selectedCycleId = this.cid;
        }
      }

      this.cyclesFiltered = this.clone(this.cycles);

      if (this.parametersApplyed) {
        this.showDetails();
      }
      
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'שגיאה בקבלת מחזורים');
      });
  }

  setGroupers() {
    this.groupers = [];
    this.cycles.forEach(c=>{
      if (!this.groupers.find(f=>f.value==c.CycleGrouper)) {
        this.groupers.push({label: c.CycleGrouper, value: c.CycleGrouper});
      }
    });
    //console.log(this.groupers);
  }

  onGrouperSelected() {
    this.viewDetails = false;
    this.tripCycleDetails2Component.clearData();
    this.selectedCycleId = null;
    this.cyclesFilter();
  }

  cyclesFilter() {
    this.cyclesFiltered = this.clone(this.cycles);
    if (this.selectedGrouper && this.selectedGrouper!='') {
      this.cyclesFiltered = this.cyclesFiltered.filter(f=>f.CycleGrouper==this.selectedGrouper);
    }
  }

  // selectCycle(cycle: Cycle) {
  //   let siteName = this.sites.find(f=>f.SiteId == this.selectedSite.SiteId).SiteName;
  //   this.tripCycleDetails2Component.fillData(cycle, siteName);
  //   this.selectedCycle = cycle;
  // }

  showDetails() {
    this.tripCycleDetails2Component.clearData();
    this.viewDetails = true;
    let mustBeConverted = false;
    let cycleCurrency = '';
    let rate: number = null;
    if (this.cycles && this.cycles.length>0) {
      mustBeConverted = this.cycles[0].mustBeConverted;
      cycleCurrency = this.cycles[0].CycleCurrency;
      rate = this.cycles[0].Rate;
    }
    this.tripCycleDetails2Component.fillData(this.selectedCategory?this.selectedCategory.TripCategoryId:null, this.selectedSite.SiteId, this.selectedCycleId, this.selectedOrderStatus?this.selectedOrderStatus.OrderStatusId:null, this.selectedGrouper, mustBeConverted, cycleCurrency, rate);
  }

  closeDetails() {
    //this.selectedCycle = null;
  }
  

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  clone(o) {
    return JSON.parse(JSON.stringify(o));
  }

  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/trip-cycles-2/trip-cycles-2.component.ts